import { render, staticRenderFns } from "./vendorDetailsDashboard.vue?vue&type=template&id=73b93f39&scoped=true&"
import script from "./vendorDetailsDashboard.vue?vue&type=script&lang=js&"
export * from "./vendorDetailsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b93f39",
  null
  
)

export default component.exports